import { render, staticRenderFns } from "./TreatmentTypes.vue?vue&type=template&id=9d350cce&scoped=true"
import script from "./TreatmentTypes.vue?vue&type=script&lang=js"
export * from "./TreatmentTypes.vue?vue&type=script&lang=js"
import style0 from "./TreatmentTypes.vue?vue&type=style&index=0&id=9d350cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d350cce",
  null
  
)

export default component.exports